import React from 'react';
import useAutomationTextFormatter from '../../hooks/useAutomationTextFormatter';

/**
 * Renders an Automation Studio text value with stored-form tokens resolved to
 * display form. Handles both `${_id:<uuid>}` variables and `@[<fileId>]` file refs.
 *
 * Props:
 *   - text     : string | undefined | null  — raw stored text to render
 *   - as       : HTML tag to render (default: "span"). Set to "pre" etc. as needed.
 *   - fallback : ReactNode to render when `text` is empty/nullish (default: null)
 *   - ...rest  : forwarded to the rendered element (className, style, title, onClick, etc.)
 *
 * Use this for read-only display of text that may contain variable tokens.
 * For editable fields continue to use `SmartInputBox` (it already handles
 * two-way conversion of stored ids ↔ display names).
 */
export default function AutomationText({
    text,
    as: Tag = 'span',
    fallback = null,
    ...rest
}) {
    const { format } = useAutomationTextFormatter();

    if (text == null || text === '') return fallback;
    const rendered = format(text);
    if (rendered == null || rendered === '') return fallback;

    return <Tag {...rest}>{rendered}</Tag>;
}
